import { useContext, useEffect, useState } from 'react';
import { Card, CardBody, Col, Form, Input, Label, Media, Row } from 'reactstrap';
import { DateFormateChange, getChangedFields, isEmpty, maxLengthCheck, toCamelCase } from '../../utils/helper';
import './AccommodationForm.css';
import { toast, Zoom, ToastContainer } from 'react-toastify';
import PublicPageContext from '../../context/PublicPageContext/PublicPageContext';
import {
  CreatePersoneMaster_Public,
  Donation_bill_Details_Public,
  UpdatePersoneMaster_Public
} from '../../api/DonationBillApi/DonationCillapi';
import { useNavigate, useParams } from 'react-router';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { DialCodeList } from '../../api/DialCodeApi/DialCodeApi';
import { CLIENT_TYPE } from '../../constant';
import { FILE_API } from '../../api/Organization Api/OrganizationApi';
import PublicHeaderComponent from '../../common/PublicHeaderComponent';
import Loader2 from '../../loader/Loader2';

import { Get_Booking_Invite_Detail_Public } from '../../api/AccommodationApi/AccommodationApi';

const initialState = Object.freeze({
  address: '',
  name: '',
  date: '',
  contactNo: '',
  dialCode: '+91',
  village: '',
  city: '',
  state: '',
  country: '',
  gender: '',
  pinCode: '',
  personId: '',
  idProofFront: '',
  idProofBack: '',
  dob: ''
});

const AccommodationForm = () => {
  const { dialCode } = useContext(PublicPageContext);
  const [formData, setFormData] = useState(initialState);
  const [imageOne, setImageOne] = useState(null);
  const [imageTwo, setImageTwo] = useState(null);
  const [token, setToken] = useState('');
  const history = useNavigate();
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [imgError, setImgError] = useState({
    image1: null,
    image2: null
  });
  const [click, setClick] = useState(false);
  const { orgId: routeOrgId, templeUuid: routeTempleUuid, trustUuid: routeTrustUuid, inviteToken } = useParams();
  const [inviteData, setInviteData] = useState(null);
  const [inviteError, setInviteError] = useState(null);
  const [isInviteLoading, setIsInviteLoading] = useState(Boolean(inviteToken));
  const [originalPersonData, setOriginalPersonData] = useState(null);

  const orgId = inviteData?.orgId || routeOrgId;
  const templeUuid = inviteData?.templeUuid || routeTempleUuid;
  const trustUuid = inviteData?.trustUuid || routeTrustUuid;

  const [dialCodeJson, setDialCodeJson] = useState([]);
  const ImageBase =
    process.env.REACT_APP_IMAGE_URL || 'https://bytebiz.fra1.cdn.digitaloceanspaces.com/mcode/hisab-kitab/';

  useEffect(() => {
    if (!inviteToken) {
      setInviteError(
        'Direct booking via this link has been deactivated. Accommodation bookings now strictly require a valid private invitation link generated by temple administration. Please contact the temple desk to receive an active link.'
      );
      setIsInviteLoading(false);
      return;
    }

    const fetchInvite = async () => {
      setIsInviteLoading(true);
      try {
        const { data } = await Get_Booking_Invite_Detail_Public(inviteToken);
        if (data?.status === 200) {
          const payload = data.payload;
          if (!payload.isUsable) {
            setInviteError(
              payload.status === 'used'
                ? 'This booking link has already been used. Each link is for one-time booking only. Please contact the administrator for a new booking link.'
                : 'This booking link has expired (links are valid for 48 hours). Please contact the administrator for a new booking link.'
            );
          } else {
            setInviteData(payload);
            if (payload.guestName) {
              setFormData((prev) => ({ ...prev, name: payload.guestName }));
            }
            if (payload.guestMobile) {
              const cleanDigits = String(payload.guestMobile).replace(/\D/g, '').slice(-10);
              const currentDial = dialCode || '+91';
              const formattedMobile = payload.guestMobile.includes(' ') || payload.guestMobile.startsWith('+')
                ? payload.guestMobile
                : `${currentDial} ${cleanDigits || payload.guestMobile}`;

              setFormData((prev) => ({
                ...prev,
                contactNo: cleanDigits || payload.guestMobile,
                dialCode: currentDial
              }));

              showHandle({
                mobileNumber: formattedMobile,
                value: cleanDigits || payload.guestMobile,
                currentOrgId: payload.orgId,
                fallbackGuestName: payload.guestName
              });
            }
          }
        } else {
          setInviteError(data?.message || 'Invalid booking link');
        }
      } catch (error) {
        setInviteError(error?.response?.data?.message || 'Invalid or expired booking link');
      } finally {
        setIsInviteLoading(false);
      }
    };
    fetchInvite();
  }, [inviteToken]);

  const showHandle = async ({ mobileNumber: mobile, value, currentOrgId, fallbackGuestName }) => {
    try {
      const targetOrgId = currentOrgId || orgId;
      const { data } = await Donation_bill_Details_Public(mobile, targetOrgId);
      if (data?.status === 200) {
        let payload = data.payload.data;

        if (payload !== null && payload !== undefined) {
          setOriginalPersonData(payload);
          setFormData((prev) => ({
            ...prev,
            contactNo: value,
            name: payload.name ? payload.name : (fallbackGuestName || prev.name || ''),
            village: payload.village ? payload.village : '',
            panCard: payload.panCardNo ? payload.panCardNo : '',
            aadhaarCard: payload.aadhaarCard ? payload.aadhaarCard : '',
            city: payload.city ? payload.city : '',
            state: payload.state ? payload.state : '',
            country: payload.country ? payload.country : '',
            address: payload.address ? payload.address : '',
            dob: payload.dob ? new Date(DateFormateChange(payload.dob)) : '',
            personId: payload.personId ? payload.personId : '',
            gender: payload.gender ? payload.gender : '',
            pinCode: payload.pinCode ? payload.pinCode : '',
            idProofFront: payload.idProofFront === 'DOCUMENT_EXISTS' ? 'DOCUMENT_EXISTS' : (payload.idProofFront ? ImageBase + payload.idProofFront : ''),
            idProofBack: payload.idProofBack === 'DOCUMENT_EXISTS' ? 'DOCUMENT_EXISTS' : (payload.idProofBack ? ImageBase + payload.idProofBack : '')
          }));
          setToken(data?.payload?.personToken);
        } else {
          setOriginalPersonData(null);
          return true;
        }
      }
    } catch (error) {
      toast.error(error.response, {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };

  useEffect(() => {
    setDialCodeJson(DialCodeList());
  }, []);

  const emptyUserDetails = () => {
    setOriginalPersonData(null);
    const { contactNo, dialCode, ...rest } = initialState;
    setFormData((prev) => ({
      ...prev,
      ...rest
    }));
  };

  const handleChangeDialCode = async (value) => {
    const contact = formData?.contactNo;
    if (value && contact?.length === 10) {
      const isEmpty = await showHandle({ mobileNumber: `${value} ${contact}`, value: contact });
      if (isEmpty && typeof isEmpty === 'boolean') {
        emptyUserDetails();
      }
    }
  };

  const emplyFeild = () => {
    setFormData(initialState);
    setOriginalPersonData(null);
    setImageOne(null);
    setImageTwo(null);
  };
  const extractImagePath = (url) => {
    if (!url) return '';

    // Find "User/" and return everything after that
    const index = url.lastIndexOf('User/');
    if (index === -1) return '';

    return url.substring(index); // returns "User/xxxx.jpg"
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    if (!formData.idProofFront) {
      setImgError((prev) => ({
        ...prev,
        image2: 'Front ID Proof is required to proceed. Please upload front side of government ID.'
      }));
      toast.error('Please upload Front ID Proof image before proceeding.', {
        autoClose: 3500,
        transition: Zoom
      });
      const el = document.getElementById('frontProofCard');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    setIsSubmitting(true);
    try {
      if (formData?.personId) {
        // Build payload sending ONLY fields that were modified by the user
        const updatePayload = getChangedFields(formData, originalPersonData, {
          alwaysInclude: { templeUuid, orgId },
          fields: {
            name: 'name',
            village: 'village',
            city: 'city',
            state: 'state',
            country: 'country',
            address: 'address',
            gender: 'gender',
            pinCode: 'pinCode',
            panCard: 'panCardNo',
            aadhaarCard: 'aadhaarCard',
            idProofFront: 'idProofFront',
            idProofBack: 'idProofBack',
            dob: 'dob',
            mobile: 'mobile'
          },
          transforms: {
            mobile: (_, form) => `${form.dialCode || '+91'} ${form.contactNo || ''}`.trim(),
            dob: (val) => (val ? moment(val).format('YYYY-MM-DD') : ''),
            idProofFront: (val) => extractImagePath(val),
            idProofBack: (val) => extractImagePath(val)
          }
        });

        const { data } = await UpdatePersoneMaster_Public(updatePayload, formData?.personId, token);
        console.log('data >> ', data);

        if (data.status === 200) {
          toast.success(data.message, {
            autoClose: 1000,
            transition: Zoom
          });
          emplyFeild();
          if (inviteToken) {
            history(`/accommodation/invite/${inviteToken}/${formData?.personId}`);
          }
          setClick(false);
        } else {
        }
      } else {
        let newFormData = isEmpty({
          ...formData,
          mobile: `${formData.dialCode} ${formData?.contactNo}`,
          dob: formData.dob ? moment(formData.dob).format('yyyy-MM-DD') : null,
          templeUuid,
          idProofBack: extractImagePath(formData.idProofBack),
          idProofFront: extractImagePath(formData.idProofFront),
          orgId
        });
        const { data } = await CreatePersoneMaster_Public(newFormData);
        console.log('data >> ', data.payload.personId);
        if (data.status === 200) {
          toast.success(data.message, {
            autoClose: 1000,
            transition: Zoom
          });
          setToken(data?.payload?.personToken);
          emplyFeild();
          if (inviteToken) {
            history(`/accommodation/invite/${inviteToken}/${data.payload.personId}`);
          }
          setClick(false);
        } else {
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Error saving person details', {
        autoClose: 2000,
        transition: Zoom
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    const fields = ['name', 'city', 'state', 'country'];
    setFormData((prev) => ({ ...prev, [name]: fields.includes(name) ? toCamelCase(value) : value }));
    if (['dialCode', 'contactNo'].includes(name)) {
      if (name === 'dialCode') {
        handleChangeDialCode(value);
      } else if (value.length === 10 && name === 'contactNo') {
        const isEmpty = await showHandle({ mobileNumber: `${dialCode} ${value}`, value });
        if (isEmpty) {
          emptyUserDetails();
          setImageOne(null);
          setImageTwo(null);
        }
      } else if (name === 'contactNo' && value.length < 10) {
        emptyUserDetails();
        setImageOne(null);
        setImageTwo(null);
      }
    }
  };

  const readUrl = async (event) => {
    if (!event.target.files || event.target.files.length === 0) return;
    const file = event.target.files[0];
    if (!file.type || !file.type.match(/image\/*/)) {
      toast.error('Please select a valid image file', { autoClose: 2000, transition: Zoom });
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event) => {
      setImageOne(reader.result);
    };

    setIsImageLoading(true);
    let formData = new FormData();
    formData.append('type', CLIENT_TYPE.USER);
    formData.append('file', file);
    try {
      const { data } = await FILE_API(formData);
      if (data.status === 200) {
        toast.success(data.message, {
          autoClose: 1000,
          transition: Zoom
        });
        setFormData((prev) => ({ ...prev, idProofFront: data.payload.imageUrl }));
        setImgError((prev) => ({
          ...prev,
          image2: null
        }));
      }
    } catch (error) {
      setImgError((prev) => ({
        ...prev,
        image2: error?.response?.data?.message || 'Image upload Error'
      }));
      setImageOne(null);
      toast.error(error?.response?.data?.message || 'Image upload failed', {
        autoClose: 1000,
        transition: Zoom
      });
    } finally {
      setIsImageLoading(false);
    }
  };

  const readUrl2 = async (event) => {
    if (!event.target.files || event.target.files.length === 0) return;
    const file = event.target.files[0];
    if (!file.type || !file.type.match(/image\/*/)) {
      toast.error('Please select a valid image file', { autoClose: 2000, transition: Zoom });
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event) => {
      setImageTwo(reader.result);
    };

    setIsImageLoading(true);
    let formData = new FormData();
    formData.append('type', CLIENT_TYPE.USER);
    formData.append('file', file);
    try {
      const { data } = await FILE_API(formData);
      if (data.status === 200) {
        toast.success(data.message, {
          autoClose: 1000,
          transition: Zoom
        });
        setImgError((prev) => ({
          ...prev,
          image1: null
        }));
        setFormData((prev) => ({ ...prev, idProofBack: data.payload.imageUrl }));
      }
    } catch (error) {
      setImgError((prev) => ({
        ...prev,
        image1: error?.response?.data?.message || 'Image upload Error'
      }));
      setImageTwo(null);
      toast.error(error?.response?.data?.message || 'Image upload failed', {
        autoClose: 1000,
        transition: Zoom
      });
    } finally {
      setIsImageLoading(false);
    }
  };

  return (
    <div className="panel">
      <ToastContainer />
      {(click === true || isInviteLoading || isSubmitting) && <Loader2 />}
      <div className="donarbackGround">
        {/* <div className="contentStyles"> */}
        <PublicHeaderComponent secondTitle="blue" therdTitle="black" templeUuid={templeUuid} />
        <Col sm="12" className="donarcontainer p-2">
          {inviteError ? (
            <Card className="doanrbackgroundcolor text-center p-4 shadow-sm my-4">
              <CardBody className="py-5">
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
                <h4 className="text-danger mb-3 fw-bold">Booking Link Unavailable</h4>
                <p className="text-muted mb-4" style={{ fontSize: '15px', maxWidth: '580px', margin: '0 auto', lineHeight: '1.6' }}>
                  {inviteError}
                </p>
                <div className="mt-2">
                  <span className="badge bg-secondary p-2" style={{ fontSize: '13px' }}>
                    Single-Use Secure Link Policy
                  </span>
                </div>
              </CardBody>
            </Card>
          ) : (
            <Card className="doanrbackgroundcolor accommodation-card">
              <CardBody className="p-4">
                {inviteData && inviteData.isUsable && (
                  <div className="reservation-banner-wrapper">
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                      <div className="d-flex align-items-center gap-2">
                        <span style={{ fontSize: '18px' }}>🔒</span>
                        <div>
                          <div className="fw-bold text-dark" style={{ fontSize: '15px' }}>
                            Pre-Approved Guest Reservation
                          </div>
                          {inviteData.guestName && (
                            <small className="text-muted">
                              Welcome, <strong className="text-dark">{inviteData.guestName}</strong>! Details pre-filled below.
                            </small>
                          )}
                        </div>
                      </div>
                      <span className="badge bg-primary px-3 py-2" style={{ fontSize: '12px', borderRadius: '20px' }}>
                        Single-Use Secure Link
                      </span>
                    </div>

                    <div className="reservation-dates-row">
                      <div className="date-pill-box">
                        <span className="date-pill-label">🗓️ Reserved Check-In</span>
                        <span className="date-pill-value">
                          {moment(inviteData.checkInDateTime).format('DD MMM YYYY, hh:mm A')}
                        </span>
                      </div>

                      <span className="date-connector-icon">➔</span>

                      <div className="date-pill-box">
                        <span className="date-pill-label">🗓️ Reserved Check-Out</span>
                        <span className="date-pill-value">
                          {moment(inviteData.checkOutDateTime).format('DD MMM YYYY, hh:mm A')}
                        </span>
                      </div>

                      {inviteData.maxGuests && (
                        <>
                          <span className="date-connector-icon">•</span>
                          <div className="date-pill-box">
                            <span className="date-pill-label">👥 Max Allowed Guests</span>
                            <span className="date-pill-value">
                              {inviteData.maxGuests} {inviteData.maxGuests === 1 ? 'Person' : 'Persons'}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
                <Row>
                  <Col sm="12">
                    <Form className="needs-validation" onSubmit={(e) => onSubmit(e)}>
                      {/* Row 1: Contact, Name, Gender, DOB */}
                      <Row>
                        <Col md="3" sm="6" className="mb-3">
                          <Label className="form-label-custom" htmlFor="contactNo">{'Contact No. (संपर्क नंबर)*'}</Label>
                          <div className="d-flex">
                            <select
                              className="form-control colorBlack dial-code-select-custom"
                              onChange={(e) => handleChange(e)}
                              value={formData.dialCode}
                              name="dialCode"
                              id="dialCode"
                            >
                              <option value={''}>{'--'}</option>
                              {dialCodeJson.map((elem) => (
                                <option key={elem.code} value={elem.code}>{elem.country}</option>
                              ))}
                            </select>
                            <Input
                              className="form-control colorBlack form-control-custom contact-input-custom"
                              name="contactNo"
                              type="number"
                              id="contactNo"
                              placeholder={'Contact No.'}
                              min={0}
                              maxLength={10}
                              onInput={maxLengthCheck}
                              value={formData.contactNo}
                              onChange={(e) => handleChange(e)}
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>
                        </Col>
                        <Col md="3" sm="6" className="mb-3">
                          <Label className="form-label-custom" htmlFor="name">{'Name (नाम)*'}</Label>
                          <Input
                            className="form-control colorBlack form-control-custom"
                            name="name"
                            type="text"
                            id="name"
                            placeholder={'Full Name'}
                            value={formData.name}
                            onChange={(e) => handleChange(e)}
                            required
                          />
                        </Col>
                        <Col md="3" sm="6" className="mb-3">
                          <Label className="form-label-custom" htmlFor="gender">{'Gender (लिंग)*'}</Label>
                          <select
                            className="form-control colorBlack form-control-custom"
                            onChange={(e) => handleChange(e)}
                            value={formData.gender}
                            name="gender"
                            id="gender"
                          >
                            <option value={''}>{'-- select --'}</option>
                            <option value={'male'}>Male</option>
                            <option value={'female'}>Female</option>
                          </select>
                        </Col>
                        <Col md="3" sm="6" className="mb-3">
                          <Label className="form-label-custom" htmlFor="dob">{'Birthdate (जन्म तिथि)*'}</Label>
                          <DatePicker
                            className="form-control colorBlack form-control-custom w-100"
                            selected={formData?.dob}
                            onChange={(date) =>
                              setFormData((prev) => ({ ...prev, dob: date }))
                            }
                            dateFormat="dd-MM-yyyy"
                            placeholderText="DD-MM-YYYY"
                            maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 1))}
                            required
                          />
                        </Col>
                      </Row>

                      {/* Row 2: Village, City, State, Country */}
                      <Row>
                        <Col md="3" sm="6" className="mb-3">
                          <Label className="form-label-custom" htmlFor="village">{'Village (गाँव)*'}</Label>
                          <Input
                            className="form-control colorBlack form-control-custom"
                            name="village"
                            type="text"
                            id="village"
                            placeholder={'Village'}
                            value={formData?.village}
                            onChange={(e) => handleChange(e)}
                            required
                          />
                        </Col>
                        <Col md="3" sm="6" className="mb-3">
                          <Label className="form-label-custom" htmlFor="city">{'City (शहर)'}</Label>
                          <Input
                            className="form-control colorBlack form-control-custom"
                            name="city"
                            type="text"
                            id="city"
                            placeholder={'City'}
                            value={formData?.city}
                            onChange={(e) => handleChange(e)}
                          />
                        </Col>
                        <Col md="3" sm="6" className="mb-3">
                          <Label className="form-label-custom" htmlFor="state">{'State (राज्य)'}</Label>
                          <Input
                            className="form-control colorBlack form-control-custom"
                            name="state"
                            type="text"
                            id="state"
                            placeholder={'State'}
                            value={formData?.state}
                            onChange={(e) => handleChange(e)}
                          />
                        </Col>
                        <Col md="3" sm="6" className="mb-3">
                          <Label className="form-label-custom" htmlFor="country">{'Country (देश)'}</Label>
                          <Input
                            className="form-control colorBlack form-control-custom"
                            name="country"
                            type="text"
                            id="country"
                            placeholder={'Country'}
                            value={formData?.country}
                            onChange={(e) => handleChange(e)}
                          />
                        </Col>
                      </Row>

                      {/* Row 3: PinCode (3 cols) + Address (9 cols) */}
                      <Row>
                        <Col md="3" sm="6" className="mb-3">
                          <Label className="form-label-custom" htmlFor="pinCode">{'PinCode (पिनकोड)'}</Label>
                          <Input
                            className="form-control colorBlack form-control-custom"
                            name="pinCode"
                            type="text"
                            id="pinCode"
                            placeholder={'PinCode'}
                            value={formData?.pinCode}
                            onChange={(e) => handleChange(e)}
                          />
                        </Col>
                        <Col md="9" sm="12" className="mb-3">
                          <Label className="form-label-custom" htmlFor="address">{'Address (पता)*'}</Label>
                          <Input
                            className="form-control colorBlack form-control-custom"
                            name="address"
                            type="textarea"
                            rows="2"
                            id="address"
                            placeholder={'Address'}
                            value={formData?.address}
                            onChange={(e) => handleChange(e)}
                            required
                          />
                        </Col>
                      </Row>

                      {/* Row 4: Symmetric ID Proof Cards */}
                      <Row className="mt-2">
                        <Col md="6" className="mb-3">
                          <div
                            id="frontProofCard"
                            className="proof-upload-card"
                            style={imgError.image2 ? { border: '2px solid #ef4444', backgroundColor: '#fff5f5' } : {}}
                          >
                            <div className="proof-card-header">
                              <span className={`proof-card-title ${imgError.image2 ? 'text-danger' : ''}`}>Front ID Proof *</span>
                              {formData.idProofFront === 'DOCUMENT_EXISTS' && !imageOne ? (
                                <span className="badge" style={{ backgroundColor: '#ecfdf5', color: '#059669', border: '1px solid #a7f3d0' }}>
                                  ✓ Verified on File
                                </span>
                              ) : imageOne || formData.idProofFront ? (
                                <span className="badge" style={{ backgroundColor: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe' }}>
                                  ✓ Uploaded
                                </span>
                              ) : (
                                <span className="badge" style={{ backgroundColor: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca' }}>
                                  Required
                                </span>
                              )}
                            </div>

                            <div className="proof-preview-area">
                              {formData.idProofFront === 'DOCUMENT_EXISTS' && !imageOne ? (
                                <div className="proof-verified-box">
                                  <div style={{ fontSize: '24px', marginBottom: '4px' }}>🛡️</div>
                                  <div className="fw-bold" style={{ fontSize: '13px' }}>ID Proof Verified on File</div>
                                  <div className="small text-muted">Stored securely with your profile. No need to re-upload.</div>
                                </div>
                              ) : imageOne || formData.idProofFront ? (
                                <img
                                  src={imageOne || formData.idProofFront}
                                  alt="Front ID Proof"
                                  style={{ maxHeight: '110px', maxWidth: '100%', objectFit: 'contain', borderRadius: '6px' }}
                                />
                              ) : (
                                <div className="text-muted text-center py-2">
                                  <div style={{ fontSize: '24px' }}>🪪</div>
                                  <div className="small mt-1">Upload Front side of Government ID</div>
                                </div>
                              )}
                            </div>

                            <div>
                              <label htmlFor="frontProofFile" className="custom-proof-btn">
                                <i className="icofont icofont-upload-alt me-1"></i>
                                {imageOne || formData.idProofFront ? 'Replace Front Proof' : 'Upload Front Proof'}
                              </label>
                              <input
                                id="frontProofFile"
                                className="d-none"
                                type="file"
                                accept="image/*"
                                onChange={(e) => readUrl(e)}
                              />
                              {imgError.image2 && (
                                <div className="text-danger small mt-2 fw-bold">
                                  ⚠ {imgError.image2}
                                </div>
                              )}
                            </div>
                          </div>
                        </Col>

                        <Col md="6" className="mb-3">
                          <div className="proof-upload-card">
                            <div className="proof-card-header">
                              <span className="proof-card-title">Back ID Proof (Optional)</span>
                              {formData.idProofBack === 'DOCUMENT_EXISTS' && !imageTwo ? (
                                <span className="badge" style={{ backgroundColor: '#ecfdf5', color: '#059669', border: '1px solid #a7f3d0' }}>
                                  ✓ Verified on File
                                </span>
                              ) : imageTwo || formData.idProofBack ? (
                                <span className="badge" style={{ backgroundColor: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe' }}>
                                  ✓ Uploaded
                                </span>
                              ) : (
                                <span className="badge" style={{ backgroundColor: '#f8fafc', color: '#64748b', border: '1px solid #e2e8f0' }}>
                                  Optional
                              </span>
                            )}
                          </div>

                          <div className="proof-preview-area">
                            {formData.idProofBack === 'DOCUMENT_EXISTS' && !imageTwo ? (
                              <div className="proof-verified-box">
                                <div style={{ fontSize: '24px', marginBottom: '4px' }}>🛡️</div>
                                <div className="fw-bold" style={{ fontSize: '13px' }}>Back ID Proof Verified on File</div>
                                <div className="small text-muted">Stored securely with your profile. No need to re-upload.</div>
                              </div>
                            ) : imageTwo || formData.idProofBack ? (
                              <img
                                src={imageTwo || formData.idProofBack}
                                alt="Back ID Proof"
                                style={{ maxHeight: '110px', maxWidth: '100%', objectFit: 'contain', borderRadius: '6px' }}
                              />
                            ) : (
                              <div className="text-muted text-center py-2">
                                <div style={{ fontSize: '24px' }}>🪪</div>
                                <div className="small mt-1">Upload Back side of Government ID</div>
                              </div>
                            )}
                          </div>

                          <div>
                            <label htmlFor="backProofFile" className="custom-proof-btn">
                              <i className="icofont icofont-upload-alt me-1"></i>
                              {imageTwo || formData.idProofBack ? 'Replace Back Proof' : 'Upload Back Proof'}
                            </label>
                            <input
                              id="backProofFile"
                              className="d-none"
                              type="file"
                              accept="image/*"
                              onChange={(e) => readUrl2(e)}
                            />
                            {imgError.image1 && <div className="text-danger small mt-1">{imgError.image1}</div>}
                          </div>
                        </div>
                      </Col>
                    </Row>

                    {isImageLoading && (
                      <div className="alert alert-info py-2 px-3 small my-2 d-flex align-items-center">
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Please wait, your ID proof image is being uploaded...
                      </div>
                    )}

                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mt-4 pt-3 border-top">
                      <div className="text-muted small">
                        <span>🔒 Single-use reservation • Your details are protected</span>
                      </div>
                      <button
                        className="btn-accommodation-next"
                        type="submit"
                        disabled={click === true || isImageLoading || isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Saving Details...
                          </>
                        ) : isImageLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Uploading Proof...
                          </>
                        ) : (
                          <>
                            Continue to Room Selection ➔
                          </>
                        )}
                      </button>
                    </div>
                  </Form>
                </Col>
              </Row>
            </CardBody>
          </Card>
          )}
        </Col>
        {/* </div> */}
      </div>
    </div>
  );
};

export default AccommodationForm;
